import { Link } from 'react-router-dom';
import { PosterImage } from '@/components/ui/PosterImage';
import { EpisodeListSkeleton } from '@/components/ui/Skeleton';
import { ErrorState } from '@/components/ui/StateMessage';
import { formatRelativeTime } from '@/lib/format';
import type { AnimeSummary } from '@/types/anime';

interface LatestEpisodesProps {
	items: AnimeSummary[];
	isLoading?: boolean;
	error?: unknown;
	onRetry?: () => void;
}

/**
 * Dải "Tập mới cập nhật". Dữ liệu là chính danh sách hoạt hình sắp theo
 * `modified.time` — API không có endpoint "tập mới" riêng cho hoạt hình.
 */
export function LatestEpisodes({
	items,
	isLoading = false,
	error,
	onRetry,
}: LatestEpisodesProps) {
	if (isLoading) return <EpisodeListSkeleton />;
	if (error) return <ErrorState error={error} onRetry={onRetry} />;

	return (
		<div className="grid gap-3.5 min-[700px]:grid-cols-2 min-[1100px]:grid-cols-4">
			{items.map((anime) => (
				<Link
					key={anime.slug}
					to={`/phim/${anime.slug}`}
					className="flex min-w-0 items-center gap-3 rounded-card border border-line bg-surface p-2.5 transition duration-200 hover:-translate-y-0.5 hover:border-iris/40 hover:bg-linear-to-br hover:from-surface hover:to-[#1a1934]"
				>
					<PosterImage
						src={anime.thumbUrl}
						alt={`Ảnh ${anime.title}`}
						className="size-[59px] shrink-0 rounded-lg object-cover"
					/>
					<div className="min-w-0">
						<b className="block truncate text-[13px]">{anime.title}</b>
						<span className="block truncate text-xs text-accent">
							{anime.episodeCurrent || 'Đang phát'}
						</span>
						<span className="block truncate text-[11px] text-muted">
							{formatRelativeTime(anime.updatedAt) || anime.lang}
						</span>
					</div>
				</Link>
			))}
		</div>
	);
}
